import React from "react";
import Icon from "../../component/Icon";

import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";
import "./style.css";

const ToolPage: React.FC = () => (
  <Jumbotron
    flexDirection="column"
    justifyContent="center"
    textAlign="center"
    minHeight="100vh"
  >
    <Text text="TOOLS" fs="60px" fontWeight="bold" />
    <Jumbotron
      flexDirection="row"
      justifyContent="center"
      textAlign="left"
      height="70%"
      margin="100px auto"
      width="100%%"
    >
      <Icon onHoverText="Jira" altText="jira" src="./tools/jira.svg"/>
      <Icon onHoverText="Sentry" altText="sentry" src="./tools/sentry.svg"/>
      <Icon onHoverText="Cloudflare" altText="cloudflare" src="./tools/cloudflare.svg"/>
      <Icon onHoverText="Apache" altText="apache" src="./tools/apache.svg"/>
      <Icon onHoverText="Beamer" altText="beamer" src="./tools/beamer.svg"/>
      <Icon onHoverText="VScode" altText="vscode" src="./tools/vscode.svg"/>
      <Icon onHoverText="Github" altText="github" src="./tools/github.svg"/>
      <Icon onHoverText="Hotjar" altText="hotjar" src="./tools/hotjar.svg"/>
      <Icon onHoverText="AWS" altText="aws" src="./tools/aws.svg"/>
    </Jumbotron>
  </Jumbotron>
);

export default ToolPage;
